import React, { useContext, useEffect, useState } from 'react'
import theme from '@ifca-root/react-component/src/assets/theme'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelUploadInput'
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { useLocation, useParams } from 'react-router-dom'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useHistory } from 'react-router'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { ItemExcelInput } from '@account-root/procurement-react/src/containers/GeneralSettingModule/Item/ItemImportExcelDialog'
import { BatchExcelInput } from 'components/ExcelImport/BatchExcelInput'
import {
  useCreateApInvoiceExcelMutation,
  useGetApInvoiceImportCheckingValidationLazyQuery,
  useImportApInvoiceExcelMutation,
  useCreateApCreditNoteExcelMutation,
  useGetApCreditNoteImportCheckingValidationLazyQuery,
  useImportApCreditNoteExcelMutation,
} from 'generated/graphql'
import { APImportTemplateForm } from '../APListing/APImportExcelFn'

export const APImportExcelValidation = (props: any) => {
  const { apSubmenu } = props
  let location = useLocation()
  const passedData: any = location?.state
  const fileName = passedData.fileTitle
  let history = useHistory()
  const { CompanyID, BatchID }: any = useParams()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openUpload, setOpenUpload] = useState(null)
  const [openDialog, setOpenDialog] = useState(null)
  const [allList, setAllList] = useState([])
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [IsOB, setIsOB] = useState(passedData?.IsOB ?? false)

  console.log('see passedData', passedData)

  const [
    loadDataInv,
    {
      loading: APInvoiceImportValidationLoading,
      error: APInvoiceImportCheckingValidationError,
      data: { getAPInvoiceImportCheckingValidation } = {
        getAPInvoiceImportCheckingValidation: [],
      },
    },
  ] = useGetApInvoiceImportCheckingValidationLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAPInvoiceImportCheckingValidation }) => {
      if (getAPInvoiceImportCheckingValidation?.length > 0) {
        let ErrorData: any = []
        let ValidData: any = []

        getAPInvoiceImportCheckingValidation?.map(x => {
          if (x['err_status'] === true)
            ErrorData.push({
              DocDate: x['DocDate'],
              TransactionDate: x['TransactionDate'],
              DocNo: x['DocNo'],
              RefNo: x['RefNo'],
              Description: x['Description'],
              CreditorName: x['CreditorName'],
              HeaderRemark: x['HeaderRemark'],
              ItemName: x['ItemName'],
              DepartmentCode: x['DepartmentCode'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              ItemRemark: x['ItemRemark'],
              Quantity: x['Quantity'],
              UnitPrice: x['UnitPrice'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
          else
            ValidData.push({
              DocDate: x['DocDate'],
              TransactionDate: x['TransactionDate'],
              DocNo: x['DocNo'],
              RefNo: x['RefNo'],
              Description: x['Description'],
              CreditorName: x['CreditorName'],
              HeaderRemark: x['HeaderRemark'],
              ItemName: x['ItemName'],
              DepartmentCode: x['DepartmentCode'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              ItemRemark: x['ItemRemark'],
              Quantity: x['Quantity'],
              UnitPrice: x['UnitPrice'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
        })

        setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
        setAllList([
          ...allList,
          ...[...validatedData.ErrorData, ...validatedData.ValidData],
        ])
      }
    },
  })

  const [
    loadDataCN,
    {
      loading: APCreditNoteImportValidationLoading,
      error: APCreditNoteImportValidationError,
      data: { getAPCreditNoteImportCheckingValidation } = {
        getAPCreditNoteImportCheckingValidation: [],
      },
    },
  ] = useGetApCreditNoteImportCheckingValidationLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAPCreditNoteImportCheckingValidation }) => {
      if (getAPCreditNoteImportCheckingValidation?.length > 0) {
        let ErrorData: any = []
        let ValidData: any = []

        getAPCreditNoteImportCheckingValidation?.map(x => {
          if (x['err_status'] === true)
            ErrorData.push({
              DocDate: x['DocDate'],
              TransactionDate: x['TransactionDate'],
              DocNo: x['DocNo'],
              RefNo: x['RefNo'],
              Description: x['Description'],
              CreditorName: x['CreditorName'],
              HeaderRemark: x['HeaderRemark'],
              ItemName: x['ItemName'],
              DepartmentCode: x['DepartmentCode'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              ItemRemark: x['ItemRemark'],
              Quantity: x['Quantity'],
              UnitPrice: x['UnitPrice'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
          else
            ValidData.push({
              DocDate: x['DocDate'],
              TransactionDate: x['TransactionDate'],
              DocNo: x['DocNo'],
              RefNo: x['RefNo'],
              Description: x['Description'],
              CreditorName: x['CreditorName'],
              HeaderRemark: x['HeaderRemark'],
              ItemName: x['ItemName'],
              DepartmentCode: x['DepartmentCode'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              ItemRemark: x['ItemRemark'],
              Quantity: x['Quantity'],
              UnitPrice: x['UnitPrice'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
        })

        setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
        setAllList([
          ...allList,
          ...[...validatedData.ErrorData, ...validatedData.ValidData],
        ])
      }
    },
  })

  const [
    ImportInvExcel,
    { loading: ImportAPInvExcelLoading, error: createInvError },
  ] = useImportApInvoiceExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      setValidatedData({ ErrorData: [], ValidData: [] })
      loadData({
        variables: {
          BatchID: BatchID ?? passedData?.BatchID,
          take: 30,
          skip: 0,
        },
      })
      history.push({
        pathname: validationPath,
        state: {
          BatchID: BatchID,
          fileTitle: fileTitle,
          IsOB: IsOB,
        },
      })
    },
  })

  const [
    ImportCNExcel,
    { loading: ImportAPCNExcelLoading, error: createCNError },
  ] = useImportApCreditNoteExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      setValidatedData({ ErrorData: [], ValidData: [] })
      loadData({
        variables: {
          BatchID: BatchID ?? passedData?.BatchID,
          take: 30,
          skip: 0,
        },
      })
      history.push({
        pathname: validationPath,
        state: {
          BatchID: BatchID,
          fileTitle: fileTitle,
          IsOB: IsOB,
        },
      })
    },
  })

  const [
    ConfirmUploadInv,
    { loading: CreateAPInvExcelLoading, error: confirmInvUploadError },
  ] = useCreateApInvoiceExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      history.push({
        pathname: backPath,
      })
      setSnackBarMsg(SystemMsgs.createNewRecord)
      setOpenSnackBar(true)
    },
  })

  const [
    ConfirmUploadCN,
    { loading: CreateAPCNExcelLoading, error: confirmCNUploadError },
  ] = useCreateApCreditNoteExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      history.push({
        pathname: backPath,
      })
      setSnackBarMsg(SystemMsgs.createNewRecord)
      setOpenSnackBar(true)
    },
  })

  let title,
    validationPath,
    backPath,
    itemLabel,
    moduleLabel,
    ConfirmUpload,
    loadData,
    ImportAPI,
    ImportAPIInput,
    ImportValidationLoading
  switch (apSubmenu) {
    case 'invoice':
      title = 'Invoice'
      validationPath = `/account-payable/${CompanyID}/invoice/import-invoice-validation/${BatchID}`
      backPath = `/account-payable/${CompanyID}/invoice`
      itemLabel = 'Invoice'
      moduleLabel = 'Account Payable'
      loadData = loadDataInv
      ConfirmUpload = ConfirmUploadInv
      ImportAPI = ImportInvExcel
      ImportAPIInput = 'APInvoiceImportInput'
      ImportValidationLoading = APInvoiceImportValidationLoading
      break
    case 'credit-note':
      title = 'Credit Note'
      validationPath = `/account-payable/${CompanyID}/credit-note/import-credit-note-validation/${BatchID}`
      backPath = `/account-payable/${CompanyID}/credit-note`
      itemLabel = 'Debit Adjustment'
      moduleLabel = 'Account Payable'
      loadData = loadDataCN
      ConfirmUpload = ConfirmUploadCN
      ImportAPI = ImportCNExcel
      ImportAPIInput = 'APCreditNoteImportInput'
      ImportValidationLoading = APCreditNoteImportValidationLoading
      break
  }

  useEffect(() => {
    loadData({
      variables: {
        BatchID: BatchID ?? passedData?.BatchID,
        take: 30,
        skip: 0,
      },
    })
  }, [])

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  const onImport = data => {
    ImportAPI({
      variables: {
        BatchID: BatchID,
        CompanyID: CompanyID,
        [ImportAPIInput]: data?.map(x => {
          return {
            DocDate:
              x?.DocDate === null ? null : new Date(x?.DocDate).toISOString(),
            TransactionDate:
              x?.TransactionDate === null
                ? null
                : new Date(x?.TransactionDate).toISOString(),
            DocNo: x?.DocNo === null ? null : `${x?.DocNo}`,
            RefNo: x?.RefNo === null ? null : `${x?.RefNo}`,
            Description: x?.Description === null ? null : `${x?.Description}`,
            CreditorName:
              x?.CreditorName === null ? null : `${x?.CreditorName}`,
            HeaderRemark:
              x?.HeaderRemark === null ? null : `${x?.HeaderRemark}`,
            ItemName: x?.ItemName === null ? null : `${x?.ItemName}`,
            DepartmentCode:
              x?.DepartmentCode === null ? null : `${x?.DepartmentCode}`,
            UOMCode: x?.UOMCode === null ? null : `${x?.UOMCode}`,
            TaxSchemeName:
              x?.TaxSchemeName === null ? null : `${x?.TaxSchemeName}`,
            ItemRemark: x?.ItemRemark === null ? null : `${x?.ItemRemark}`,
            Quantity: x?.Quantity === null ? null : Number(x?.Quantity),
            UnitPrice: x?.UnitPrice === null ? null : Number(x?.UnitPrice),
            RowNo: x?.rowNo,
          }
        }),
      },
    })
  }

  const onConfirm = () => {
    ConfirmUpload({ variables: { BatchID, IsOB } })
  }

  return (
    <>
      {ImportValidationLoading && <Loading />}
      {ImportAPInvExcelLoading && <Loading />}
      {ImportAPCNExcelLoading && <Loading />}
      {CreateAPInvExcelLoading && <Loading />}
      {CreateAPCNExcelLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(backPath)}
        smTitle={moduleLabel}
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: itemLabel, current: true },
        ]}
      />

      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={`${itemLabel} Excel Upload`}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <div style={{ width: '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <div className="xsTitle">{fileName}</div>

                  {IsOB && (
                    <div className="xsTitle">{''}(Opening/Closing Balance)</div>
                  )}
                </div>
              </div>
            }
          />
        </ListItem>
      </List>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        <InfiniteScroll
          dataLength={allList?.length}
          next={() => {
            loadData({
              variables: {
                BatchID: BatchID ?? passedData?.BatchID,
                skip: allList?.length,
                take: 30,
              },
            })
          }}
          hasMore={true}
          className=""
          style={{ padding: '8px 6px' }}
          loader={
            ImportValidationLoading && (
              <div style={{ textAlign: 'center' }}>
                {' '}
                <CircularProgress />{' '}
              </div>
            )
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>-</b>
            </p>
          }
        >
          {/* Problem List */}
          {validatedData.ErrorData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Problem{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {validatedData.ErrorData?.length}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ErrorData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space ">
                                DocDate:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {formatDate(el.DocDate)}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                TransactionDate:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {formatDate(el.TransactionDate)}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DocNo:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DocNo}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                RefNo:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.RefNo}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                CreditorName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.CreditorName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                HeaderRemark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.HeaderRemark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DepartmentCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DepartmentCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                UOMCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.UOMCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                TaxSchemeName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.TaxSchemeName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemRemark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemRemark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Quantity:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Quantity}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                UnitPrice:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.UnitPrice}{' '}
                              </span>
                            </div>
                          </div>
                        </>
                      }
                      secondary={
                        <>
                          <div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {' '}
                              Row No: {el.RowNo}
                            </div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {el.ErrorList}
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {/* Validation List */}
          {validatedData.ValidData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Validated{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {validatedData.ValidData?.length}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ValidData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div
                              style={{ boxSizing: 'border-box', width: '50%' }}
                            >
                              <span className="xsTitle flex-space ">
                                DocDate:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {formatDate(el.DocDate)}{' '}
                              </span>
                            </div>

                            <div
                              style={{ boxSizing: 'border-box', width: '50%' }}
                            >
                              <span className="xsTitle flex-space ">
                                TransactionDate:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {formatDate(el.TransactionDate)}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DocNo:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DocNo}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                RefNo:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.RefNo}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                CreditorName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.CreditorName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                HeaderRemark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.HeaderRemark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DepartmentCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DepartmentCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                UOMCode:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.UOMCode}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                TaxSchemeName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.TaxSchemeName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemRemark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemRemark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Quantity:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Quantity}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                UnitPrice:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.UnitPrice}{' '}
                              </span>
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </InfiniteScroll>
      </ContentWrapper>

      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true)
                  },
                },
              ]
        }
      />

      <BatchExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        labelDisplay={itemLabel}
        setIsOB={setIsOB}
        onUploadTemplate={() => {
          onImport(currentData)
          setOpenFileUpload(false)
          localStorage.removeItem('searchFilter')
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() =>
          onDownloadTemplate({
            name: `AP ${itemLabel} Template`,
            workSheetName: `${itemLabel} List`,
            headerSetup: APImportTemplateForm,
            isHeaderLocked: true,
            defaultHeaderFillStyle: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            },
            defaultHeaderBorderStyle: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            },
            listType: {
              hasCountry: true,
              hasNationality: true,
            },
          })
        }
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onConfirm()
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
